import { useState } from 'react';
import { Dot } from '@givebutter/primitives/dot';
import { PledgeFormValue } from 'assets/js/pages/pledges/usePledgeForm';
import * as Form from 'components/form';
import * as Select from 'components/select';
import useDebounce from 'customHooks/useDebounce';
import { useInfiniteCampaignsByActiveStatus } from 'customHooks/useInfiniteCampaignsByActiveStatus';

const SelectCampaign = () => {
    const methods = Form.useFormContext<PledgeFormValue>();
    const { control } = methods;
    const [query, setQuery] = useState('');
    const debouncedSearchCampaigns = useDebounce(query);

    const { data: campaignData, ref } = useInfiniteCampaignsByActiveStatus({
        query: debouncedSearchCampaigns,
        sortBy: 'active',
    });
    const campaigns = campaignData?.pages;

    return (
        <Select.UseFormSearchableSelect
            name="campaign"
            control={control}
            localSearch={false}
            inputProps={{
                placeholder: 'Select a campaign',
                onChange: e => {
                    setQuery(e.currentTarget.value);
                },
            }}
            onSelectItem={value => {
                if (!value) {
                    setQuery('');
                }
            }}
            rules={{ required: 'Please select a campaign.' }}
        >
            {campaigns?.map(campaign => (
                <Select.ListItem
                    key={campaign.id.toString()}
                    value={{
                        id: campaign.id.toString(),
                        label: campaign.title,
                    }}
                >
                    <Dot className={campaign.active ? 'bg-green-500' : 'bg-red-500'} />
                    {campaign.title}
                </Select.ListItem>
            ))}
            <div ref={ref} />
        </Select.UseFormSearchableSelect>
    );
};

export { SelectCampaign };
